import { Component, OnInit, Input } from '@angular/core';
import { Classification } from '@app-model/group-classification';
import { ConfigurationService } from '@app-services/configuration.service';

@Component({
    selector: 'app-eligible-filter-view',
    templateUrl: './eligible-filter-view.component.html',
    styleUrls: ['./eligible-filter-view.component.scss'],
    standalone: false
})
export class EligibleFilterViewComponent implements OnInit {
	@Input() classification: Classification;

	listDepartament = [];
	listRoles = [];
	listCompany = [];
	constructor(private configurationService: ConfigurationService) {}

	ngOnInit() {
    if(this.classification.companyIds.length < 20) {
      this.classification.companyIds.forEach(comp => {
        this.configurationService.getCompany(comp).subscribe(res => {
          this.listCompany.push(res);
        });
      });
    } else{
      this.listDepartament.push({"name":"Contém mais de 20 items"});
    }
    if(this.classification.departamentIds.length < 100) {
      this.classification.departamentIds.forEach(dep => {
      	this.configurationService.getDepartament(dep).subscribe(res => {
      		this.listDepartament.push(res);
      	});
      });
    }else{
      this.listDepartament.push({"name":"Contém mais de 100 items"});
    }
    if(this.classification.roleIds.length < 100) {
      this.classification.roleIds.forEach(role => {
        this.configurationService.getRole(role).subscribe(res => {
          this.listRoles.push(res);
        });
      });
    } else{
      this.listRoles.push({"name":"Contém mais de 100 items"});
    }
	}

	listUsers() {
		let u = this.classification.users.map(u => u.name);
		let resultado = u.join(', ');
		return resultado;
	}
}
